import React, { Component } from 'react'
import { Button, Grid, Form } from 'semantic-ui-react';
import { isMobile, isTablet } from 'react-device-detect';
import BankSingleOptionRow from '../../bankAccounts/components/BankSingleOptionRow';
import config from '../../../config';

const _s = {
    borderBottom: { borderBottom: '1px solid #ddd' },
    borderTop: { borderTop: '1px solid #ddd' },
    noMargin: { margin: 0 },
    alignRight: { textAlign: 'right' },
    title: {
        fontSize: '12px',
        color: '#aaa',
        textTransform: 'uppercase',
        margin: '0',
    }
};

export default class WithdrawForm extends Component {

    selectAccount = selectedAccount => {
        const { selectAccount } = this.props;

        if (typeof selectAccount === 'function')
            selectAccount(selectedAccount);
    }

    render() {
        const { bank, cancel, generateOTP, openModal, payment: { selectedBankAccount, withdrawfees: { withdrawFee, withdrawAmount } } } = this.props;

        if (!withdrawFee) return null;

        return (
            <>
                <Form onSubmit={generateOTP}>
                    <Grid stackable>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <Grid>
                                    <Grid.Row style={_s.borderBottom}>
                                        <Grid.Column width={16}>
                                            <h5 style={{ ..._s.title }}>Withdraw amount</h5>
                                            <h2 className="rupeeIcon" style={{ ..._s.noMargin, marginBottom: '20px' }}><span>{withdrawFee.amount + withdrawAmount.amount}</span></h2>
                                        </Grid.Column>
                                    </Grid.Row>

                                    <Grid.Row style={_s.borderBottom}>
                                        <Grid.Column width={8}>
                                            <h5 style={{ ..._s.title }}>{withdrawFee.name}</h5>
                                            <h4 className="rupeeIcon" style={_s.noMargin}><span>{withdrawFee.amount}</span></h4>
                                        </Grid.Column>

                                        <Grid.Column width={8} style={{ ..._s.alignRight }}>
                                            <h5 style={{ ..._s.title }}>{withdrawAmount.name}</h5>
                                            <h4 className="rupeeIcon" style={_s.noMargin}><span>{withdrawAmount.amount}</span></h4>
                                        </Grid.Column>
                                    </Grid.Row>

                                    <BankSingleOptionRow bank={bank} selectAccount={this.selectAccount} selectedAccount={selectedBankAccount} />

                                    <Grid.Row>
                                        <div style={{ width: '100%' }}>
                                            {
                                                bank &&
                                                bank.get &&
                                                bank.get.data &&
                                                Array.isArray(bank.get.data) &&
                                                bank.get.data.length < config.bankAccountLimit &&
                                                <Button
                                                    icon="plus"
                                                    content="Add account"
                                                    onClick={() => {
                                                        if (typeof openModal === 'function') {
                                                            openModal('AddBankAccountModal');
                                                        }
                                                    }}
                                                    style={{ float: 'right' }}
                                                    type="button"
                                                />
                                            }
                                        </div>
                                    </Grid.Row>

                                    <Grid.Row>
                                        <Button

                                            className={`fcbtn fccancelbtn ${
                                                isMobile || isTablet ? 'mobileandtab' : ''
                                                }`}
                                            onClick={cancel}
                                        >
                                            Cancel
                                    </Button>
                                        <Button
                                            className={`fcbtn fcprimary ${
                                                isMobile || isTablet ? 'mobileandtab' : ''
                                                }`}
                                            type="submit"
                                        >
                                            Generate OTP
                                    </Button>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
            </>
        )
    }

    componentDidMount() {
        const { bank } = this.props;

        const bankData = bank && bank.get && bank.get.data;
        const bankDataIsArr = bankData && Array.isArray(bankData);

        // IF user has single account THEN default select first account
        if (bankDataIsArr && bankData.length === 1) {
            this.selectAccount(bankData[0]);
        }
    }

    componentWillUnmount() {
        // Deselect bank account
        this.selectAccount({});
    }
}
